<template>
  <div id="download">
      <!-- 导航栏和搜索框头部部分 -->
      <v-header  :selectedItemVal="4"></v-header>
	  
	  <div class="main">
		  <div class="download">
			<div class="download-bg">
				<img src="../../assets/img/download/download_app2.png" alt="">
			</div>
			
			<div class="android-test">
				<img src="../../assets/img/footer/AndroidDownload.png" alt="">
			</div>
			
			<!-- <div class="qrcode">
				<div class="android">
					<img src="" alt="">
					<div>Android下载</div>
				</div>
				<div class="ios">
					<img src="" alt="">
					<div>IOS下载</div>
				</div>
			</div> -->
		  </div>
	  </div>
	  
	  <v-footer></v-footer>
  </div>
</template>

<script>
import vHeader from '../common/header'

import vFooter from '../common/footer'

export default {
	components: {
      'v-header': vHeader,
	  'v-footer':vFooter
    },
}
</script>

<style>
	.download{
		width: 1200px;
		height: 1726px;
		margin: 0 auto;
		background-color: #FFFFFF;
		margin-top: 24px;
		margin-bottom: 50px;
		position: relative;
	}
	
	.download-bg img{
		width: 100%;
		height: auto;
	}
	
	.qrcode{
		position: absolute;
		top: 25%;
		width: 30%;
		left: 10%;
		text-align: center;
		display: flex;
		justify-content: space-around;
	}
	
	.android-test{
		position: absolute;
		top: 22%;
		left: 14%;
	}
	
	.top{
		border: 1px solid red;
		height: 40%;
	}
	
	.middle{
		border: 1px solid red;
		height: 30%;
	}
	
	.bottom{
		border: 1px solid red;
		height: 20%;
	}
</style>


// WEBPACK FOOTER //
// src/components/download_app/downloadApp.vue